import styled, { css } from 'styled-components';
import { TagsBadgeListType } from './TagsBadgeList';

export const BadgesContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['position'].includes(prop),
})<{ position?: TagsBadgeListType['position'] }>`
  ${({ theme, position }) => {
    return css`
      ${position === 'absolute' &&
      css`
        position: absolute;
        top: 0.5rem;
        left: 0;
      `}
      width: 100%;
      height: auto;
      padding: 0 0.5rem;

      display: flex;
      flex-wrap: wrap;
      gap: 0.175rem;
      > span {
        display: inline-block;
        flex-grow: 0;
        flex-shrink: 0;
        box-shadow: ${theme.box_shadow.base};
        text-transform: uppercase !important;
      }
    `;
  }};
`;
